import { pick } from 'lodash';
import { DEFAULT_SUBSET_ATTRIBUTE_KEYS } from './const/studentManagementConstants';

const buildStudentGroupingPayload = (
  groupList = [],
  schoolNameById = {},
  subsetKeys = DEFAULT_SUBSET_ATTRIBUTE_KEYS
) => {
  const schools = new Map();
  const yearIndex = new Map();
  const cocurriculumGroups = [];

  const ensureSchool = (schoolId) => {
    const key = `${schoolId}`;
    if (!schools.has(key)) {
      schools.set(key, { id: key, name: `${schoolNameById[key] || key}`, years: new Map() });
    }
    return schools.get(key);
  };

  groupList.forEach((row) => {
    if (row.school) {
      const year = { id: `${row.id}`, name: row.group, classes: [], subjects: [] };
      ensureSchool(row.school).years.set(`${row.id}`, year);
      yearIndex.set(`${row.id}`, year);
    } else if (row.customGroup && !row.parent) {
      cocurriculumGroups.push({ id: `${row.id}`, name: row.group });
    }
  });

  groupList.forEach((row) => {
    if (!row.parent || row.school) {
      return;
    }
    const year = yearIndex.get(`${row.parent}`);
    if (!year) {
      return;
    }
    const node = { id: `${row.id}`, name: row.group };
    if (row.subjectGroup) {
      year.subjects.push(node);
    } else {
      year.classes.push(node);
    }
  });

  const schoolGroups = [...schools.values()].map((school) => ({
    id: school.id,
    name: school.name,
    years: [...school.years.values()]
  }));

  const allGroups = groupList.map((row) => ({
    id: `${row.id}`,
    name: row.group,
    ...pick(row, subsetKeys)
  }));

  return { schoolGroups, cocurriculumGroups, allGroups };
};

export default buildStudentGroupingPayload;
